import { Box, Stack } from '@mui/material';
import {
  liveTranscriptWaveBarSx,
  liveTranscriptWaveformRootSx,
} from 'src/components/Assistant/live-transcript/live-transcript.styles';

interface LiveTranscriptWaveformProps {
  isFinished: boolean;
  isStreaming: boolean;
}

const BARS: {
  key: string;
  staticHeight: string;
  animationName: string;
  delay: string;
}[] = [
  { key: 'bar-1', staticHeight: '0.5rem', animationName: 'liveWave1', delay: '0s' },
  { key: 'bar-2', staticHeight: '0.875rem', animationName: 'liveWave2', delay: '0.2s' },
  { key: 'bar-3', staticHeight: '0.625rem', animationName: 'liveWave3', delay: '0.35s' },
  { key: 'bar-4', staticHeight: '0.75rem', animationName: 'liveWave4', delay: '0.5s' },
];

export const LiveTranscriptWaveform = ({
  isFinished,
  isStreaming,
}: LiveTranscriptWaveformProps) => (
  <Stack direction="row" sx={liveTranscriptWaveformRootSx}>
    {BARS.map((bar) => (
      <Box
        key={bar.key}
        sx={liveTranscriptWaveBarSx({
          isFinished,
          isStreaming,
          staticHeight: bar.staticHeight,
          animationName: bar.animationName,
          delay: bar.delay,
        })}
      />
    ))}
  </Stack>
);
